import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ folderId: number; stationCodes: string[] }>,
) => {
  const { folderId, stationCodes } = payloadAction.payload;

  const updatedStationCodes = [
    ...(state.catalogs.data[folderId].stationCodes || []),
    ...stationCodes,
  ];

  state.catalogs.data = {
    ...state.catalogs.data,
    [folderId]: {
      ...state.catalogs.data[folderId],
      stationCodes: updatedStationCodes,
    },
  };
};

export default action;
